import { IOption } from '@user/components/Filters'

export type LeadType =
  | 'Manual'
  | 'Phone'
  | 'Web'
  | 'Mobile'
  | 'ServiceBot'
  | 'Import'

export const LeadTypeOptions: IOption[] = [
  { label: 'Manual', value: 'Manual' },
  { label: 'Phone', value: 'Phone' },
  { label: 'Web', value: 'Web' },
  { label: 'Mobile', value: 'Mobile' },
]

export const leadTypeServiceBotOption = [
  { label: 'Service Bot', value: 'ServiceBot' },
]
export const leadTypeImportOption = [{ label: 'Import', value: 'Import' }]

export const leadTypeOptionsLeadAssignment = [
  { label: 'Phone', id: 'Phone' },
  { label: 'Web', id: 'Web' },
  { label: 'Mobile', id: 'Mobile' },
]

export const leadTypeServiceBotOptionAssignment = [
  { label: 'Service Bot', id: 'ServiceBot' },
]
export const leadTypeImportOptionAssignment = [
  { label: 'Import', id: 'Import' },
]

export interface ImportFilterDTO {
  id: number
  name: string
}

export interface AgreementType {
  id: string
  name: string
}
